"use client";

import React, { createContext, useContext, useMemo, ReactNode } from "react";
import { ProblemHistory } from "../types/problem";

interface ProblemHistoryContextValue {
  histories: Record<string, ProblemHistory | null>;
  isLoading: boolean;
}

const ProblemHistoryContext = createContext<ProblemHistoryContextValue | null>(null);

// Provider 없이 사용될 때 매 렌더마다 새 객체 생성을 방지하기 위한 안정적 기본값
const DEFAULT_CONTEXT: ProblemHistoryContextValue = {
  histories: {},
  isLoading: false,
};

export const useProblemHistory = () => {
  const context = useContext(ProblemHistoryContext);
  return context ?? DEFAULT_CONTEXT;
};

interface ProblemHistoryProviderProps {
  children: ReactNode;
  histories: Record<string, ProblemHistory | null>;
  isLoading: boolean;
}

export const ProblemHistoryProvider: React.FC<ProblemHistoryProviderProps> = ({
  children,
  histories,
  isLoading,
}) => {
  const value = useMemo(() => ({ histories, isLoading }), [histories, isLoading]);
  return (
    <ProblemHistoryContext.Provider value={value}>
      {children}
    </ProblemHistoryContext.Provider>
  );
};
